import React from 'react';
import { Copy } from 'lucide-react';
import './ForkModal.css';

interface ForkGateModalProps {
  planTitle: string;
  creatorName: string;
  destination: string;
  onSignUp: () => void;
  onClose: () => void;
}

// The intent helpers live in utils/forkIntent so the user store can resume a
// fork without importing a component module; re-exported here because this
// is where callers have always found them.
export { storeForkIntent, storeSharedForkIntent, getForkIntent, clearForkIntent } from '../../utils/forkIntent';

const ForkGateModal: React.FC<ForkGateModalProps> = ({
  planTitle,
  creatorName,
  destination,
  onSignUp,
  onClose,
}) => {
  return (
    <div className="fork-modal-backdrop" onClick={onClose}>
      <div className="fork-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fork-modal-handle" />

        <div className="fork-modal-icon">
          <Copy size={24} />
        </div>
        <h3 className="fork-modal-title">Save "{planTitle}"</h3>
        <p className="fork-modal-subtitle">
          by {creatorName} · {destination}
        </p>
        <p className="fork-modal-desc">
          Sign up to save this plan. It's free.
          Your copy will be waiting.
        </p>

        <button className="fork-modal-primary-btn" onClick={onSignUp}>
          Sign up to save this plan
        </button>
        <button className="fork-modal-dismiss" onClick={onClose}>
          Just browsing
        </button>
      </div>
    </div>
  );
};

export default ForkGateModal;
